import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { useAxiosInstance } from "../../../services/Interceptor";
import { updateUserBio } from "../../../services/AthleteService";

export default function AdminUpdateBio({ initialBio = "" }) {
  const [bio, setBio] = useState(initialBio || "");
  const [isUpdatingBio, setIsUpdatingBio] = useState(false);
  const apiInstance = useAxiosInstance();
  const authUser = useAuthUser();

  useEffect(() => {
    setBio(initialBio || "");
  }, [initialBio]);

  const handleUpdateBio = async (e) => {
    e.preventDefault();

    if (!bio?.trim()) {
      toast.warning("Bio cannot be empty.", { position: "top-right" });
      return;
    }

    if (bio?.length > 500) {
      toast.warning("Bio cannot exceed 500 characters.", {
        position: "top-right",
      });
      return;
    }

    try {
      setIsUpdatingBio(true);
      const response = await updateUserBio(
        apiInstance,
        authUser?.user?.id,
        bio,
      );
      if (response) {
        setBio(response.bio);
        toast.success("Bio updated successfully!", { position: "top-right" });
      }
    } catch (error) {
      toast.error("Error updating bio: " + error.message, {
        position: "top-right",
      });
    } finally {
      setIsUpdatingBio(false);
    }
  };

  return (
    <form className="w-full mt-0" onSubmit={handleUpdateBio}>
      <div className="bg-white shadow-lg p-4 rounded-lg">
        <h1 className="text-xl mb-6 uppercase">UPDATE BIO</h1>
        <textarea
          className="w-full p-2 border border-gray-300 rounded-md"
          placeholder="Write your bio here..."
          value={bio}
          onChange={(e) => setBio(e.target.value)}
          style={{
            maxHeight: "400px",
            overflow: "auto",
            resize: "vertical",
          }}
          maxLength={500}
        />
        <div className="text-right text-sm text-gray-500 mt-1">
          {bio?.length}/500 characters
        </div>
        <div className="flex justify-center mt-4">
          <button
            type="submit"
            className={`mt-2 px-4 py-2 rounded-md ${
              isUpdatingBio ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-800"
            } text-white`}
            disabled={isUpdatingBio}
          >
            {isUpdatingBio ? "Updating..." : "UPDATE  BIO"}
          </button>
        </div>
      </div>
    </form>
  );
}
